/**
 * @generated SignedSource<<dac1402ee9d10d77f0d2f7de876aade7>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type snapshotGetQuery$variables = {
  snapshotCode: string;
  type: string;
};
export type snapshotGetQuery$data = {
  readonly getApplyRefundCertificate: {
    readonly message: string | null | undefined;
    readonly result: boolean;
    readonly snapshotData: string | null | undefined;
  };
};
export type snapshotGetQuery = {
  response: snapshotGetQuery$data;
  variables: snapshotGetQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "snapshotCode"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "type"
},
v2 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "snapshotCode",
        "variableName": "snapshotCode"
      },
      {
        "kind": "Variable",
        "name": "type",
        "variableName": "type"
      }
    ],
    "concreteType": "GetApplyCertificationOutput",
    "kind": "LinkedField",
    "name": "getApplyRefundCertificate",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "result",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "snapshotData",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "message",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "snapshotGetQuery",
    "selections": (v2/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "snapshotGetQuery",
    "selections": (v2/*: any*/)
  },
  "params": {
    "cacheID": "e33ac45c0cc543e1f5d72762d2c29bd2",
    "id": null,
    "metadata": {},
    "name": "snapshotGetQuery",
    "operationKind": "query",
    "text": "query snapshotGetQuery(\n  $type: String!\n  $snapshotCode: String!\n) {\n  getApplyRefundCertificate(type: $type, snapshotCode: $snapshotCode) {\n    result\n    snapshotData\n    message\n  }\n}\n"
  }
};
})();

(node as any).hash = "e97610a0e2181754c7062113e954afb9";

export default node;
